// Notes:
import "intersection-observer";

export default function() {
  const doc = document.querySelector("body");


  // - Check browser modernity
  if (!!window.IntersectionObserver) {
    // -- Add observer
    addObserver();
  } else {
    // -- No observer
    doc.classList.add("no-inview");
  }

  // - Methods
  // -- Add Observer
  function addObserver() {

    // -- Data
    let previousY = 0;
    let previousRatio = 0;

    // callback function to do animations
    const Observations = (entries, observer) => {
      entries.forEach(entry => {
        // - Settings
        // -- Current
        const currentY = entry.boundingClientRect.y;
        const currentRatio = entry.intersectionRatio;
        const isIntersecting = entry.isIntersecting;

        // -- Check type
        if(entry.target.classList.contains('step--parent')) {
          var elementClass = '-play-parent'
        } else {
          var elementClass = '-play'
        }

        // In/Out
        if (entry.isIntersecting) {
          // Step (active)
          entry.target.classList.add(elementClass);
        } else {
          // Step (inactive)
          entry.target.classList.remove(elementClass);
        }

        previousY = currentY;
        previousRatio = currentRatio;

      });
    };

    // create the observer
    const options = {
      threshold: .2
    };
    const observer = new IntersectionObserver(Observations, options);

    // target the elements to be observed
    const boxes = document.querySelectorAll(".step");
    boxes.forEach(box => {
      observer.observe(box);
    });
  }
}
